import './WizardModal.css';
import React from 'react';
import { CloseButton } from '../CloseButton/CloseButton';
import StepsLine from '../StepsLine/StepsLine';
import { useOnKeyPress } from '../../../utils/hooks/useOnKeyPress';
var WizardModal = function WizardModal(_ref) {
  var rtl = _ref.rtl,
    currentStepId = _ref.currentStepId,
    steps = _ref.steps,
    children = _ref.children,
    title = _ref.title,
    hide = _ref.hide;
  useOnKeyPress(["Escape", "Esc"], hide);
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles),
    role: "dialog",
    "aria-labelledby": "wizard-title"
  }, /*#__PURE__*/React.createElement("div", {
    className: "wizard__header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "wizard__header-top"
  }, /*#__PURE__*/React.createElement("h1", {
    id: "wizard-title",
    className: "wizard__title"
  }, title), /*#__PURE__*/React.createElement(CloseButton, {
    className: "wizard__close",
    onClick: hide
  })), /*#__PURE__*/React.createElement(StepsLine, {
    rtl: rtl,
    steps: steps,
    currentStepId: currentStepId
  })), children);
};
export default WizardModal;
var commonStyles = "c1q7o6v";
var rtlStyles = "rcgwje3";
var ltrStyles = "lm5xxx";